import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import { Product, productApi } from "@/api/products";

export interface ProductState {
  products: Product[];
  productsOnSale: Product[];
}

const productModule: Module<ProductState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      products: [] as Product[],
      productsOnSale: [] as Product[],
    } as ProductState),
  mutations: {
    setAllProducts(state: ProductState, products: Product[]) {
      state.products = products;
      state.productsOnSale = products.filter((p: Product) => p.onsale);
    },
  },
  actions: {
    async listAll(context: ActionContext<ProductState, RootState>) {
      if (!context.state.products || context.state.products.length === 0) {
        context.commit("setAllProducts", await productApi.list());
      }
    },
    async addProduct(
      context: ActionContext<ProductState, RootState>,
      product: Product
    ) {
      product.id = await productApi.add(product);
      context.commit("setAllProducts", await productApi.list());
    },
    async editProduct(
      context: ActionContext<ProductState, RootState>,
      product: Product
    ) {
      if (product.id) {
        await productApi.edit(product);
        context.commit("setAllProducts", await productApi.list());
      }
    },
    async removeProduct(
      context: ActionContext<ProductState, RootState>,
      product: Product
    ) {
      if (product.id) {
        await productApi.delete(product);
        context.commit("setAllProducts", await productApi.list());
      }
    },
  },
};

export default productModule;
